// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Types
import { ProofIncomeContextType } from 'containers/proof-income/contexts/types/proof-income-landing.contexts.type';

const getMethodParam = (method: ProofIncomeContextType['selectedMethod']): Record<string, string> =>
  method === ProofIncomeMethodsEnumeration.OPENBANKING
    ? { identificationType: method }
    : { incomeType: method };

export { getMethodParam };
